module.exports = __webpack_public_path__ + "static/media/Group 120 1.1067ab01.png";